export const LAT_LNG_BRUGES = [51.20892, 3.22424];
